import React, {useState} from 'react';
import {Tab, Tabs, useMediaQuery} from "@mui/material";
import localStrings from "../../../localStrings";
import BarTurnover from "../../../Graphs/BarTurnover";
import {
    filterOrderItemsWithStaff,
    getlocations,
    getPricesOrderByHour,
    getSerieDataByLocation,
    getSerieDatabyProductTypeMode,
    getTotalSerieByProductType
} from "../../../Graphs/BarGraphUtils";
import useAuth from "../../../hooks/useAuth";

function StaffDetail({staff}) {

    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
    const {
        categories,
        products,
        locations,
        filter,
    } = useAuth();

    const [currentTab, setCurrentTab] = useState('general');

    const handleTabsChange = (event, value) => {
        setCurrentTab(value);
    };

    function transformerSumUpDays(sumUpDay, staff) {
        let totalTurnoverUpdated = 0;
        let singleStaffDetail = null;
        if (sumUpDay.detailbyStaff) {
            let staffDetail = sumUpDay.detailbyStaff[staff.id];
            if (!staffDetail) {
                staffDetail = sumUpDay.detailbyStaff[staff.name]
            }
            if (staffDetail) {
                singleStaffDetail = staffDetail;
                const locationIds = Object.keys(staffDetail.locations);
                for (const locationId of locationIds) {
                    totalTurnoverUpdated += staffDetail.locations[locationId].totalTurnover;
                }
            }
            sumUpDay.totalTurnover = totalTurnoverUpdated;
        }
        delete sumUpDay.detailbyStaff;
        sumUpDay.detailbyStaff = {};
        if (singleStaffDetail) {
            sumUpDay.detailbyStaff[staff.id] = singleStaffDetail;
        }

        return sumUpDay || {};
    }

    return (
        <div style={{width: '100%'}}>
            <Tabs
                style={{marginLeft: '15px'}}
                onChange={handleTabsChange}
                scrollButtons="auto"
                value={currentTab}
                textColor="secondary"
                variant="scrollable"

            >
                <Tab label={localStrings.general} value="general"/>
                <Tab label={localStrings.byProductType} value="byProductType"/>
                <Tab label={localStrings.byLocation} value="byLocation"/>
            </Tabs>
            <div style={{width: '100%'}}>
                {currentTab === 'general' &&
                    <BarTurnover
                        title={lgUp && localStrings.general}
                        transformer={order => {
                            return filterOrderItemsWithStaff(order, staff)
                        }}
                        transformerSumUpDays={(sumUpDay) => transformerSumUpDays(sumUpDay, staff)}

                        // product={product}
                    />
                }
                {currentTab === 'byProductType' &&
                    <BarTurnover

                        title={lgUp && localStrings.byProductType}
                        transformer={order => {
                            return filterOrderItemsWithStaff(order, staff)
                        }}
                        transformerSumUpDays={(sumUpDay) => transformerSumUpDays(sumUpDay, staff)}
                        serieBuiler={(orders, dates) => {
                            return getTotalSerieByProductType(orders, dates, products, categories)
                        }}
                        serieBuilerSumUpDay={
                            getSerieDatabyProductTypeMode
                        }
                    />
                }
                {currentTab === 'byLocation' &&
                    <BarTurnover
                        // displayMode={byLocationMode}
                        title={lgUp && localStrings.byLocation}
                        transformer={order => {
                            return filterOrderItemsWithStaff(order, staff)
                        }}
                        transformerSumUpDays={(sumUpDay) => transformerSumUpDays(sumUpDay, staff)}
                        serieBuiler={(orders, dates) => {
                            let series = {};
                            let locations = getlocations(orders);
                            locations.forEach(location => {
                                series[location] = {
                                    name: location || "Unknown",
                                    data: getPricesOrderByHour(orders, dates, order => {
                                        return order.location && order.location.location_name === location
                                    }
                                    )
                                }
                            })
                            return Object.values(series);
                        }}
                        serieBuilerSumUpDay={
                            (sumupDaysDetail, series, products, categories, sumUpDays) =>
                                getSerieDataByLocation(sumupDaysDetail, series,
                                    null, locations, sumUpDays,
                                    false  )
                        }
                    />
                }
            </div>
        </div>
    )
}

export default StaffDetail